import { AxiosAdapter, ReservationAdapter } from '@adapters';
import {
  BlueOneFetchReservationListResponse,
  // BlueOneTgResveConfirm,
  FetchReservationDetailPayload,
  // FetchReservationDetailResponse,
  // FetchReservationListResponse,
  TgResveTime,
} from '@core/dto';
import { COURSE_CLASS } from '@core/enums';
import { FetchReservationDetailUseCase } from '@core/useCases';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash-es';
import { computed, reactive, ref } from 'vue';

export const useReservationList = () => {
  const axiosAdapter = new AxiosAdapter();
  const reservationAdapter = new ReservationAdapter(axiosAdapter);
  const totalItems = computed(() => {
    return reservationStatus.value?.total || 0;
  });
  const totalItemsPerPage = 10;
  const currentPage = ref<number>(1);
  const reservationStatus = ref<BlueOneFetchReservationListResponse>();
  const reservationStatusResvetimesOrigin = ref<TgResveTime[]>();
  const params = reactive<{
    fromDate: string;
    toDate: string;
    limit: number;
    offset: number;
    courseClass?: COURSE_CLASS;
  }>({
    fromDate: '',
    toDate: '',
    limit: 0,
    offset: 0,
    courseClass: COURSE_CLASS.PUBLIC,
  });
  const searchParams = computed(() => {
    const fromDate = params.fromDate
      ? params.fromDate
      : dayjs().format('YYYY-MM-DD'); // 현재 날짜
    const toDate = params.toDate
      ? params.toDate
      : dayjs().add(3, 'month').format('YYYY-MM-DD'); // 3개월 후 날짜
    const limit = params.limit ? params.limit : totalItemsPerPage; // 페이지 당 항목 수
    const offset = params.offset
      ? params.offset
      : (currentPage.value - 1) * totalItemsPerPage; // 현재 페이지 오프셋
    const courseClass = params.courseClass
      ? params.courseClass
      : COURSE_CLASS.PUBLIC;
    return {
      fromDate,
      toDate,
      limit,
      offset,
      courseClass,
    };
  });

  const fetchReservationList = async () => {
    reservationStatus.value =
      await reservationAdapter.fetchReservationJoinFlagList(searchParams.value);
    reservationStatusResvetimesOrigin.value = cloneDeep(
      reservationStatus.value?.resveTimes
    );
  };

  const fetchReservationListForExcel = async () => {
    const response = await reservationAdapter.fetchReservationJoinFlagList(
      searchParams.value
    );
    return response;
  };

  const fetchReservationDetail = async (
    payload: FetchReservationDetailPayload
  ) => {
    const fetchReservationDetailUseCase = new FetchReservationDetailUseCase(
      reservationAdapter
    );
    return await fetchReservationDetailUseCase.execute(payload);
  };

  const filterReservationList = (partDiv: number) => {
    const origin = reservationStatusResvetimesOrigin.value;
    if (!origin || !reservationStatus.value) return;
    if (partDiv) {
      reservationStatus.value.resveTimes = origin.filter(
        (item) => item.partDiv === `${partDiv}`
      );
    } else {
      reservationStatus.value.resveTimes = origin;
    }
  };

  // watch(
  //   () => searchParams.value,
  //   async () => {
  //     await fetchReservationList();
  //   }
  // );

  return {
    params,
    totalItems,
    totalItemsPerPage,
    currentPage,
    reservationStatus,
    fetchReservationList,
    filterReservationList,
    fetchReservationDetail,
    fetchReservationListForExcel,
  };
};
